import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { MessageSquare, Bot } from "lucide-react";

type QuickChatWidgetProps = {
  className?: string;
};

const QuickChatWidget = ({ className = "" }: QuickChatWidgetProps) => {
  const { t } = useTranslation("widgets");

  return (
    <div className={`bg-white rounded-3xl shadow-lg p-6 relative ${className}`}>
      {/* Bot message */}
      <div className="flex items-start mb-5">
        <div className="flex-shrink-0 w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center">
          <Bot className="h-6 w-6 text-white" />
        </div>
        <div className="ml-3 bg-amber-50 px-5 py-3 rounded-2xl rounded-tl-none max-w-[85%]">
          <p className="text-amber-900">
            Chào bạn, tôi là một thiền sư AI, bạn có thể hỏi tôi bất kỳ câu hỏi nào về Phật Pháp.
          </p>
        </div>
      </div>

      {/* User message */}
      <div className="flex items-start justify-end mb-5">
        <div className="mr-3 bg-blue-50 px-5 py-3 rounded-2xl rounded-tr-none max-w-[85%]">
          <p className="text-blue-900">
            Sự khác biệt giữa Tâm (Citta) và Tâm sở (Cetasika) là gì?
          </p>
        </div>
        <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
          <span className="text-blue-800 text-lg font-medium">👤</span>
        </div>
      </div>

      {/* Bot response */}
      <div className="flex items-start mb-5">
        <div className="flex-shrink-0 w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center">
          <Bot className="h-6 w-6 text-white" />
        </div>
        <div className="ml-3 bg-amber-50 px-5 py-3 rounded-2xl rounded-tl-none max-w-[85%]">
          <p className="text-amber-900 mb-1">
          "Tâm" (Citta) và "Tâm sở" (Cetasika) là hai khái niệm quan trọng nhưng khác biệt:
          </p>
          <ul className="text-amber-900 mb-1">
            <li>- Tâm (Citta): Là yếu tố chủ đạo, có chức năng nhận biết đối tượng.</li>
            <li>- Tâm đơn thuần là sự nhận thức, biết cảnh.</li>
          </ul>
          <div className="typing-indicator">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>

      {/* Knowledge level */}
      <div className="mb-5 px-3 py-3">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-amber-900">
            Cấp độ
          </span>
          <span className="text-xs bg-amber-100 text-amber-800 px-2 py-1 rounded-full">
            Sơ cấp
          </span>
        </div>
        <div className="w-full bg-amber-100 rounded-full h-2">
          <div
            className="bg-gradient-to-r from-amber-500 to-amber-300 h-2 rounded-full"
            style={{ width: "30%" }}
          ></div>
        </div>
      </div>

      {/* CTA Button */}
      <Button
        asChild
        className="w-full bg-amber-500 hover:bg-amber-600 text-white border-none h-14 rounded-xl"
      >
        <Link to="/ai-chat" className="flex items-center justify-center">
          <MessageSquare className="mr-2 h-5 w-5" />
          {t("quickChat.startChat")}
        </Link>
      </Button>
    </div>
  );
};

export default QuickChatWidget;
